<igo-ogc-filterable-list igoOgcFilterableListBinding />
